import React from 'react';
import { useLocation } from 'react-router-dom';
import { Navigation } from './Navigation';
import { DataInitializer } from '../shared';
import { ROUTES } from '../../constants';

interface AppLayoutProps {
  children: React.ReactNode;
}

/**
 * AppLayout - Main application layout wrapper
 * 
 * Conditionally renders navigation based on the current route.
 * Home page does not show navigation to provide a clean landing experience.
 * Home page also skips DataInitializer to avoid showing loading spinner.
 */
export const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  const location = useLocation();
  const isHomePage = location.pathname === ROUTES.HOME;

  // Home page - no navigation and no data initialization.
  // Uses natural document scroll so the landing content is never clipped on
  // short viewports (LandingPage provides its own full-bleed background).
  if (isHomePage) {
    return (
      <div className="min-h-screen">
        <main className="relative">
          {children}
        </main>
      </div>
    );
  }

  // Other pages - with data initialization and navigation
  return (
    <DataInitializer>
      <div className="app-shell flex flex-col">
        <Navigation />
        <main className="relative flex-1 overflow-y-auto">
          {children}
        </main>
      </div>
    </DataInitializer>
  );
};
